export const NetworkContextName = "NETWORK";
export const ACTIVE_NETWORK = 5;
export const nftAddress = "0x1adfedcc65074dc473eBffAeA2Bf06184B850Aab";
export const marketPlace = "0x3035822224Df6B9863063D7A914986dBe6b3fF28";

export const walletbalance = "0xf75f3DF0DCe0eEb7E8e072af792d8623EA4B185B";
export const etherScanLink = 'https://goerli.etherscan.io/address/'